import React, { useState } from "react";
import { Icon } from "semantic-ui-react";
import styles from "./styles.module.css";
import PropTypes from "prop-types";

const FilterCard = ({ title, icon, iconColor, headerRight, children, leftAccent, customClass, collapsible, defaultCollapsed = false }) => {
	const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

	const toggleCollapse = () => {
		if (collapsible) {
			setIsCollapsed(!isCollapsed);
		}
	};

	const handleKeyDown = (e) => {
		if (collapsible && (e.key === "Enter" || e.key === " ")) {
			e.preventDefault();
			toggleCollapse();
		}
	};

	const titleContent = (
		<>
			<div className={styles.cardIconWrapper}>{icon && <Icon name={icon} color={iconColor} className={styles.cardIcon} />}</div>
			<span className={styles.cardTitleText}>{title}</span>
			{collapsible && <Icon name={isCollapsed ? "chevron down" : "chevron up"} className={styles.collapseIcon} color="grey" />}
		</>
	);

	return (
		<div className={`${styles.filterCard} ${leftAccent ? styles.cardAccent : ""} ${customClass || ""}`}>
			{title && (
				<div className={styles.filterCardHeader}>
					{collapsible ? (
						<div
							className={`${styles.filterCardTitle} ${styles.collapsibleTitle}`}
							onClick={toggleCollapse}
							onKeyDown={handleKeyDown}
							role="button"
							tabIndex={0}>
							{titleContent}
						</div>
					) : (
						<div className={styles.filterCardTitle}>{titleContent}</div>
					)}
					{headerRight && <div className={styles.filterCardHeaderRight}>{headerRight}</div>}
				</div>
			)}
			{!isCollapsed && <div className={styles.filterCardBody}>{children}</div>}
		</div>
	);
};

FilterCard.propTypes = {
	title: PropTypes.string,
	icon: PropTypes.string,
	iconColor: PropTypes.string,
	headerRight: PropTypes.node,
	children: PropTypes.node,
	leftAccent: PropTypes.bool,
	customClass: PropTypes.string,
	collapsible: PropTypes.bool,
	defaultCollapsed: PropTypes.bool,
};

export default FilterCard;
